import { captureScreenTraits } from '@cobliteam/analytics/src/screenTraits';
import * as ReactDOM from 'react-dom/client';
import 'moment/dist/locale/pt-br';

import './tailwind.css';
import Dashboard from './Dashboard';
import { preserveInitialLoadingElement } from './pages/LoadingPage/initialLoadingElement';

async function bootstrap() {
  preserveInitialLoadingElement();

  // Demo mode: load MSW + seed data BEFORE rendering so the first network
  // call from the React tree is already intercepted. Dynamic import means
  // prod bundles tree-shake this entire branch away (vite-plugin-environment
  // inlines the env var at build time).
  if (process.env.REACT_APP_DEMO_MODE === 'true') {
    try {
      const { startDemoWorker } = await import('@cobliteam/msw-demo');
      await startDemoWorker();
    } catch (err) {
      console.error('Failed to start demo worker:', err);
    }
  }

  // Freeze the screen snapshot before the first paint: it is what the user arrived with, and
  // every analytics destination reads this same frozen value later, after auth.
  captureScreenTraits();

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<Dashboard />);
}

bootstrap();
